import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Card, CardHeader, CardBody, Nav, NavItem, NavLink, TabPane, TabContent } from 'reactstrap'
import { connect } from 'react-redux'
import { getUserPermissions } from '../../utils/userPermissions'
import { UserTab, SettingsTab, PersonTab, CompanyTab } from './tabs'

const propTypes = {
  user: PropTypes.object.isRequired
}

class Profile extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeTab: '4'
    }

    this.toggleTab = this.toggleTab.bind(this)
  }

  toggleTab(tabNo) {
    this.setState({ activeTab: tabNo })
  }

  render() {
    return (
      <Card>
        <CardHeader>
          <b>User details and application settings</b>
        </CardHeader>
        <CardBody>
          <Nav tabs>
            <NavItem>
              <NavLink
                active={this.state.activeTab === '1'}
                onClick={() => {
                  this.toggleTab('1')
                }}
              >
                <b>Person</b>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                active={this.state.activeTab === '2'}
                onClick={() => {
                  this.toggleTab('2')
                }}
              >
                <b>User</b>
              </NavLink>
            </NavItem>
            {getUserPermissions('core.companies.update') && <NavItem>
              <NavLink
                active={this.state.activeTab === '3'}
                onClick={() => {
                  this.toggleTab('3')
                }}
              >
                <b>Company</b>
              </NavLink>
            </NavItem>}
            <NavItem>
              <NavLink
                active={this.state.activeTab === '4'}
                onClick={() => {
                  this.toggleTab('4')
                }}
              >
                <b>Application settings</b>
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={this.state.activeTab[0]}>
            <TabPane tabId="1">
              {this.state.activeTab === '1' && <PersonTab personId={Number(this.props.user.data.person_id)} />}
            </TabPane>
            <TabPane tabId="2">
              {this.state.activeTab === '2' && <UserTab personId={Number(this.props.user.data.person_id)} />}
            </TabPane>
            <TabPane tabId="3">
              {this.state.activeTab === '3' && <CompanyTab />}
            </TabPane>
            <TabPane tabId="4">
              {this.state.activeTab === '4' && <SettingsTab />}
            </TabPane>
          </TabContent>
        </CardBody>
      </Card>
    )
  }
}

Profile.propTypes = propTypes

const mapStateToProps = state => ({
  user: state.user
})

export default connect(mapStateToProps, {})(Profile)



// WEBPACK FOOTER //
// ./src/components/Profile/Profile.js